export const clinicalNotesQueryKeys = [
  'clinicalNotes',
  'overview-clinical-notes',
  'clinicalNotesInfinite',
  'checkPatientNotes'
];

export const overviewLedgerQueryKeys = ['overview-ledger'];

export const MESSAGES_COUNT_QUERY_KEY = 'messagesCount';

export const COMMUNICATION_LOGS_QUERY_KEY = 'communication_logs';

export const WIZARD_TEMPLATE_QUERY_KEY = 'wizard-template';

export const HAS_SELF_SCHEDULING_QUERY_KEY = 'has-self-scheduling';

export const refundReasonsQueryKey = 'refund-reasons';
